import { loadTyroSdk } from './tyroLoader';

let cachedClient = null;
let cachedMeta = null;
let clientPromise = null;

const resolveTyroConstructor = (preferHeadless) => {
  if (preferHeadless && window.TYRO?.IClient) {
    return { ctor: window.TYRO.IClient, mode: 'headless' };
  }
  if (window.TYRO?.IClientWithUI) {
    return { ctor: window.TYRO.IClientWithUI, mode: 'ui' };
  }
  if (window.TYRO?.IClient) {
    return { ctor: window.TYRO.IClient, mode: 'headless' };
  }
  if (typeof window.TYRO?.default === 'function') {
    return { ctor: window.TYRO.default, mode: 'ui' };
  }
  return null;
};

export const getTyroClient = async ({ apiKey, posProductInfo, preferHeadless = true } = {}) => {
  if (!apiKey) {
    throw new Error('Tyro API key is required.');
  }
  await loadTyroSdk({ preferHeadlessScript: preferHeadless });
  if (!window.TYRO) {
    throw new Error('Tyro SDK not available.');
  }

  if (cachedClient) {
    if (cachedMeta?.apiKey !== apiKey) {
      console.warn('[Tyro] Reusing existing client with different API key.');
    }
    if (preferHeadless && cachedMeta?.mode === 'ui') {
      console.warn('[Tyro] Tyro client already initialized with UI; reuse for headless request.');
    }
    return cachedClient;
  }

  if (clientPromise) {
    return clientPromise;
  }

  clientPromise = (async () => {
    const resolved = resolveTyroConstructor(preferHeadless);
    if (!resolved) {
      throw new Error('Tyro SDK loaded but client constructor missing.');
    }

    cachedClient = new resolved.ctor(apiKey, posProductInfo);
    cachedMeta = {
      apiKey,
      mode: resolved.mode,
      preferHeadless: Boolean(preferHeadless),
      posProductInfo,
    };
    return cachedClient;
  })().catch((err) => {
    clientPromise = null;
    cachedClient = null;
    cachedMeta = null;
    throw err;
  });

  return clientPromise;
};

export const getTyroClientMeta = () => cachedMeta;

export const resetTyroClient = () => {
  cachedClient = null;
  cachedMeta = null;
  clientPromise = null;
};
